import { CampaignShopifyProductDetails } from '../shopify/types';
import {
  CampaignCodeSubmission,
  CampaignCodeSubmitPayload,
  QuestionnaireSubmission,
  ShopifySubmission
} from './submission';

/** what is returned from redeem-server */
class RedemptionResult {
  id: number;
  network!: number;
  tokenId!: string;
  contractAddress!: string;
  submissions?: Array<QuestionnaireSubmission | ShopifySubmission | CampaignCodeSubmission>;

  name?: string;
  description?: string;
  image?: string;
  eip5131Address?: string;
  eip5639Address?: string;
  delegateAddress?: string;
  ownerAddress?: string;

  campaignId!: number;

  constructor(
    id: number,
    network: number,
    contractAddress: string,
    tokenId: string,
    submissions:
      | Array<QuestionnaireSubmission | ShopifySubmission | CampaignCodeSubmission>
      | undefined = undefined,
    name: string,
    description: string,
    image: string,
    eip5131Address: string,
    eip5639Address: string,
    delegateAddress: string,
    ownerAddress: string,
    campaignId: number
  ) {
    this.id = id;
    this.network = network;
    this.tokenId = tokenId;
    this.contractAddress = contractAddress;
    this.submissions = submissions;
    this.name = name;
    this.description = description;
    this.image = image;
    this.eip5131Address = eip5131Address;
    this.eip5639Address = eip5639Address;
    this.delegateAddress = delegateAddress;
    this.ownerAddress = ownerAddress;
    this.campaignId = campaignId;
  }

  static fromJson(data: any) {
    return new RedemptionResult(
      data.id,
      data.network,
      data.contractAddress,
      data.tokenId,
      data.submissions,
      data.nft.name,
      data.nft.metadata ? data.nft.metadata.description : '',
      data.nft.image,
      data.nft.eip5131Address ? data.nft.eip5131Address : '',
      data.nft.eip5639Address ? data.nft.eip5639Address : '',
      data.delegateAddress ? data.delegateAddress : '',
      data.ownerAddress ? data.ownerAddress : '',
      data.campaignId
    );
  }
}

/** used to submit to our /redemption endpoint */
class Redemption {
  id: number;
  network!: number;
  tokenAddress!: string;
  tokenId!: string;
  submissions?: Array<QuestionnaireSubmission | ShopifySubmission | CampaignCodeSubmitPayload>;
  contractAddress: string;
  product?: CampaignShopifyProductDetails;
  eip5131Address?: string;
  eip5639Address?: string;

  constructor(
    network: number,
    contractAddress: string,
    tokenId: string,
    submissions:
      | Array<QuestionnaireSubmission | ShopifySubmission | CampaignCodeSubmitPayload>
      | undefined = undefined,
    eip5131Address: string,
    eip5639Address: string
  ) {
    this.network = network;
    this.tokenId = tokenId;
    this.tokenAddress = contractAddress;
    this.submissions = submissions;
    this.eip5131Address = eip5131Address;
    this.eip5639Address = eip5639Address;
  }

  static fromJson(data: any) {
    return new Redemption(
      data.network,
      data.contractAddress,
      data.tokenId,
      data.submissions,
      data.eip5131Address,
      data.eip5639Address
    );
  }
}

export { Redemption, RedemptionResult };
